// V480 — Flat-rate vs hourly compensation display helpers.
// A shift may pay a single fixed amount (pay_type === 'flat', flat_pay) or an
// hourly rate. These helpers keep the "$X flat" vs "$X/hr" labelling consistent
// across every talent/client/admin surface.

export const isFlatPay = (obj) =>
  (obj?.pay_type || 'hourly') === 'flat' && obj?.flat_pay != null;

const toNum = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

// Returns a display string like "$250.00 flat" or "$25.00/hr", or null when no
// rate is available. `hourlyFields` lets callers pass the hourly value under
// whatever key the object uses (hourly_rate, talent_pay_rate, pay_rate…).
export const formatPay = (obj, hourlyValue) => {
  if (isFlatPay(obj)) {
    const flat = toNum(obj.flat_pay);
    return flat != null ? `$${flat.toFixed(2)} flat` : null;
  }
  const hr = toNum(
    hourlyValue != null
      ? hourlyValue
      : (obj?.hourly_rate ?? obj?.talent_pay_rate ?? obj?.pay_rate),
  );
  return hr != null ? `$${hr.toFixed(2)}/hr` : null;
};

// Short unit label ("flat" | "/hr") for compact layouts.
export const payUnitLabel = (obj) => (isFlatPay(obj) ? 'flat' : '/hr');
